import { Component } from '@angular/core';

@Component({
    selector: 'tun-angle-left-icon-v5',
    templateUrl: './angle-left-icon-v5.component.html',
    styleUrls: ['./angle-left-icon-v5.component.scss'],
    standalone: false
})
export class AngleLeftIconV5Component {

}
